const locale = "es-ES";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm",
	"serviceReports.headline": "Informes de servicio",
	"serviceReports.sublineMachine": "Consulte los informes de servicio de su máquina y descárguelos.",
	"serviceReports.technicianName": "Nombre del miembro del servicio técnico",
	"serviceReports.machineNameAndNumber": "Máquina y n.º de máquina",
	"serviceReports.startDate": "Desde",
	"serviceReports.endDate": "Hasta",
	"serviceReports.creationDate": "Fecha de creación",
	"serviceReports.openReport": "Abrir informe de servicio (PDF)",
	"serviceReports.filter": "Filtros",
	"serviceReports.missionNumber": "Número de misión",
	"serviceReports.assignmentType": "Tipo de informe de servicio",
	"serviceReports.reportTypes.IA": "Informe de desinstalación/reubicación",
	"serviceReports.reportTypes.AC": "Informe de asesoramiento sobre aplicaciones",
	"serviceReports.reportTypes.IV": "Informe de preparación de la instalación",
	"serviceReports.reportTypes.BA": "Informe de evaluación",
	"serviceReports.reportTypes.UV": "Informe de inspección de seguridad",
	"serviceReports.reportTypes.IG": "Informe de instalación de máquina usada",
	"serviceReports.reportTypes.UB": "Informe de medidas de calidad",
	"serviceReports.reportTypes.PN": "Informe de asistencia en la producción",
	"serviceReports.reportTypes.NR": "Informe de reacondicionamiento",
	"serviceReports.reportTypes.IB": "Informe de instalación / puesta en marcha",
	"serviceReports.reportTypes.II": "Informe de integración de la instalación",
	"serviceReports.reportTypes.IC": "Informe de reparación interna",
	"serviceReports.reportTypes.MB": "Informe de servicio para ferias",
	"serviceReports.reportTypes.HW": "Informe de recursos",
	"serviceReports.reportTypes.TT": "Informe sobre cursos de formación para técnicos",
	"serviceReports.reportTypes.SK": "Informe de formación de clientes",
	"serviceReports.reportTypes.RP": "Informe de reparación",
	"serviceReports.reportTypes.RW": "Informe de reparación y mantenimiento",
	"serviceReports.reportTypes.WA": "Informe de mantenimiento",
	"serviceReports.reportTypesPlural.IA": "Informes de desinstalación/reubicación",
	"serviceReports.reportTypesPlural.AC": "Informes de asesoramiento sobre aplicaciones",
	"serviceReports.reportTypesPlural.IV": "Informes de preparación de la instalación",
	"serviceReports.reportTypesPlural.BA": "Informes de evaluación",
	"serviceReports.reportTypesPlural.UV": "Informes de inspección de seguridad",
	"serviceReports.reportTypesPlural.IG": "Informes de instalación de máquina usada",
	"serviceReports.reportTypesPlural.UB": "Informes de medidas de calidad",
	"serviceReports.reportTypesPlural.PN": "Informes de asistencia en la producción",
	"serviceReports.reportTypesPlural.NR": "Informes de reacondicionamiento",
	"serviceReports.reportTypesPlural.IB": "Informes de instalación / puesta en marcha",
	"serviceReports.reportTypesPlural.II": "Informes de integración de la instalación",
	"serviceReports.reportTypesPlural.IC": "Informes de reparación interna",
	"serviceReports.reportTypesPlural.MB": "Informes de servicio para ferias",
	"serviceReports.reportTypesPlural.HW": "Informes de recursos",
	"serviceReports.reportTypesPlural.TT": "Informes de cursos de formación para técnicos",
	"serviceReports.reportTypesPlural.SK": "Informes de formación de clientes",
	"serviceReports.reportTypesPlural.RP": "Informes de reparación",
	"serviceReports.reportTypesPlural.RW": "Informes de reparación y mantenimiento",
	"serviceReports.reportTypesPlural.WA": "Informes de mantenimiento",
	"serviceReports.loadMore": "Cargar más",
	"serviceReports.loadError": "Error al cargar los datos",
	"serviceReports.noReportsFound": "Actualmente no hay informes de servicio disponibles.",
	"serviceReports.noReportsAvailable": "Actualmente no hay informes de servicio disponibles.",
	missingAuthorization: "Falta de autorización",
	"headline.createCase": "Crear caso nuevo",
	"headline.caseDetails": "Detalles del caso",
	"headline.contactData": "Datos de contacto",
	"field.reason.label": "Motivo del mensaje",
	"field.machine.label": "Máquina y n.º de máquina",
	"field.softwareProblemClassification.label": "Clasificación del proyecto",
	"field.softwareInstallationProblem.label": "Problema de instalación",
	"field.softwareLicenseIssue.label": "Problema con la licencia",
	"field.softwareType.label": "Tipo de software",
	"field.softwareModule.label": "Módulo de software",
	"field.errorNumber.label": "Números de error",
	"field.errorNumber.explanation": "p. ej. 0000FC00, 1.10.58102409 o 6000",
	"field.errorNumber.addAnotherNumber": "Agregar más números de error",
	"field.errorNumber.errorMessage": "Número de error inválido",
	"field.message.label": "Mensaje",
	"field.message.placeholder": "Describa (sin saludo) tan concreto como pueda y tan detallado como sea necesario cuál es su problema/preocupación. Muchas gracias.",
	"field.fileUpload.label": "Anexos",
	"field.fileUpload.info": "Formatos de archivo permitidos: IMG, JPG, PNG, PDF, HTML, archivos TruTops, etc. (máx. 16 MB) y archivos de vídeo MP4 (máx. 50 MB)",
	"field.salutation.label": "Tratamiento",
	"field.salutation.male": "Sr.",
	"field.salutation.female": "Sra.",
	"field.firstName.label": "Nombre",
	"field.lastName.label": "Apellidos",
	"field.email.label": "Correo electrónico",
	"field.phone.label": "Número de teléfono",
	"button.submit": "Enviar",
	"button.cancel": "Cancelar",
	"button.back": "atrás",
	"button.next": "continuar",
	"button.close": "Cerrar",
	"button.ok": "Aceptar",
	"auth.error": "Se ha producido un error inesperado.",
	"select.placeholder": "Selecciona, por favor...",
	"validation.requiredField": "Este campo es obligatorio",
	"validation.invalidEmail": "Por favor, indique una dirección de correo electrónico válida",
	"validation.maxAllowedCharacters": "Cantidad de caracteres máxima permitida: {{number}}",
	"validation.requiredFieldsExplanation": "Los campos obligatorios están marcados con un *.",
	"validation.invalidPhoneNumber": "Por favor, indique un número de teléfono válido.",
	"softwareProblemClassification.standstill": "Estado de inactividad",
	"softwareProblemClassification.fault": "Fallo",
	"softwareProblemClassification.slightImpairment": "Deterioro leve",
	"softwareProblemClassification.generalInquiry": "Solicitud general",
	"serviceCase.proactiveCaseClosure.title": "Comentarios y solicitud de cierre de caso",
	"serviceCase.proactiveCaseClosure.instructions": "Para solicitar el cierre de un caso y ayudarnos a mejorar nuestro servicio de predicción, te rogamos que nos envíes tus comentarios.",
	"serviceCase.proactiveCaseClosure.question.submit": "Enviar",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Cierre de caso solicitado. Gracias por tus comentarios.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Aceptar",
	"serviceCase.proactiveCaseClosure.question.anomaly": "¿Se había producido la anomalía notificada en tu máquina?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "¿Se te facilitó una guía técnica?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "¿Pudiste solucionar el problema con ayuda de la guía o guías técnicas?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "¿Deseas suspender temporalmente las notificaciones para este tipo de anomalía?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "¿Durante cuánto tiempo deseas suspender temporalmente las notificaciones para este tipo de anomalía?",
	"serviceCase.proactiveCaseClosure.question.comment": "Explica, por favor, por qué deseas suspender temporalmente las notificaciones para este tipo de anomalía:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Comentario obligatorio para solicitar el cierre del caso y enviar comentarios",
	"serviceCase.proactiveCaseClosure.answers.yes": "Sí",
	"serviceCase.proactiveCaseClosure.answers.no": "No",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 días",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 días",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 días",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 días",
	"sisConnector.success.headline": "El caso se ha creado con éxito.",
	"sisConnector.success.orderNumberRequired.title": "Indicación:",
	"sisConnector.success.orderNumberRequired.text": "Por favor, añade un número de pedido para la resolución del caso y otros servicios en la página de detalles del caso.",
	"sisConnector.success.technicalGuide.title": "Hay disponible una guía técnica para estos números de error.",
	"sisConnector.success.technicalGuide.text": "En función de los números de error introducidos, podrían determinarse una o varias guías técnicas. En aprox. el 50 % de los casos podrás solucionar el problema por ti mismo. Esta función solo está disponible con el contrato de servicio correspondiente.",
	"sisConnector.success.outsideOfServiceHours": "Ten en cuenta que no se procesan los casos creados fuera de nuestro horario de atención al público.",
	"sisConnector.success.serviceTimes.MonFri": "Nuestros horarios de servicio: de lunes a viernes",
	"sisConnector.success.serviceTimes.Sat": "y sábado",
	"sisConnector.success.withTechnicalServiceHotline": "Si necesita asistencia inmediata, llame al Servicio Técnico de TRUMPF ({{hotline}}) para obtener ayuda.",
	"sisConnector.success.withoutTechnicalServiceHotline": "Si necesita asistencia inmediata, llame al Servicio Técnico de TRUMPF (%s) para obtener ayuda.",
	"sisConnector.success.caseId": "Número de caso",
	"sisConnector.failed.headline": "No se ha podido crear el caso.",
	"sisConnector.failed.unknownError": "Por favor, inténtelo de nuevo o póngase en contacto con el servicio técnico."
};
var esES = {
	locale: locale,
	translations: translations
};

export { esES as default, locale, translations };
//# sourceMappingURL=es-ES-CdNrP5PM.js.map

//# sourceMappingURL=es-ES-CdNrP5PM.js.map